// extracted by mini-css-extract-plugin
export default {"navigation":"CarouselNavigation_navigation__ZXMr-","vertical":"CarouselNavigation_vertical__NY7An","button":"CarouselNavigation_button__t0yQa"};